/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CounselorDutyType } from './CounselorDutyType';
import {
    CounselorDutyTypeFromJSON,
    CounselorDutyTypeFromJSONTyped,
    CounselorDutyTypeToJSON,
    CounselorDutyTypeToJSONTyped,
} from './CounselorDutyType';

/**
 * 
 * @export
 * @interface BlockedPeriodParam
 */
export interface BlockedPeriodParam {
    /**
     * 
     * @type {string}
     * @memberof BlockedPeriodParam
     */
    id: string | null;
    /**
     * 
     * @type {CounselorDutyType}
     * @memberof BlockedPeriodParam
     */
    dutyType: CounselorDutyType;
    /**
     * 
     * @type {Date}
     * @memberof BlockedPeriodParam
     */
    from: Date;
    /**
     * 
     * @type {Date}
     * @memberof BlockedPeriodParam
     */
    to: Date;
}



/**
 * Check if a given object implements the BlockedPeriodParam interface.
 */
export function instanceOfBlockedPeriodParam(value: object): value is BlockedPeriodParam {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('dutyType' in value) || value['dutyType'] === undefined) return false;
    if (!('from' in value) || value['from'] === undefined) return false;
    if (!('to' in value) || value['to'] === undefined) return false;
    return true;
}

export function BlockedPeriodParamFromJSON(json: any): BlockedPeriodParam {
    return BlockedPeriodParamFromJSONTyped(json, false);
}

export function BlockedPeriodParamFromJSONTyped(json: any, ignoreDiscriminator: boolean): BlockedPeriodParam {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'dutyType': CounselorDutyTypeFromJSON(json['dutyType']),
        'from': (new Date(json['from'])),
        'to': (new Date(json['to'])),
    };
}

export function BlockedPeriodParamToJSON(json: any): BlockedPeriodParam {
    return BlockedPeriodParamToJSONTyped(json, false);
}

export function BlockedPeriodParamToJSONTyped(value?: BlockedPeriodParam | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'dutyType': CounselorDutyTypeToJSON(value['dutyType']),
        'from': `${value['from'].getFullYear()}-${String(value['from'].getMonth()+1).padStart(2,'0')}-${String(value['from'].getDate()).padStart(2,'0')}`,
        'to': `${value['to'].getFullYear()}-${String(value['to'].getMonth()+1).padStart(2,'0')}-${String(value['to'].getDate()).padStart(2,'0')}`,
    };
}

